import { z } from "zod";
import { paginationMetaDtoSchema } from "@nasam/kernel";

const nonEmpty = z.string().min(1);

export const notificationCategoryDtoSchema = z.enum([
  "ALERT",
  "SYSTEM",
  "SUBSCRIPTION",
  "MAINTENANCE",
]);

export const notificationDtoSchema = z.object({
  id: nonEmpty,
  titleEn: nonEmpty,
  titleAr: nonEmpty,
  bodyEn: nonEmpty,
  bodyAr: nonEmpty,
  category: notificationCategoryDtoSchema,
  isRead: z.boolean(),
  createdAt: nonEmpty,
  // Leading "/" not followed by a second "/" — blocks protocol-relative
  // "//host" values that clients.openWindow() would treat as cross-origin.
  linkPath: z
    .string()
    .regex(/^\/(?!\/)/)
    .nullable(),
});

export const notificationListResponseDtoSchema = z.object({
  data: z.array(notificationDtoSchema),
  meta: paginationMetaDtoSchema,
});

export const notificationResponseDtoSchema = z.object({
  data: notificationDtoSchema,
});

export const notificationsSummaryDtoSchema = z.object({
  unreadCount: z.number().int().nonnegative(),
});

export const notificationsSummaryResponseDtoSchema = z.object({
  data: notificationsSummaryDtoSchema,
});

export const deviceTokenWriteDtoSchema = z.object({
  token: nonEmpty,
  platform: z.literal("WEB"),
});

export type NotificationDto = z.infer<typeof notificationDtoSchema>;
export type NotificationsSummaryDto = z.infer<
  typeof notificationsSummaryDtoSchema
>;
export type DeviceTokenWriteDto = z.infer<typeof deviceTokenWriteDtoSchema>;
